import { Control, FieldValues, FieldPath } from 'react-hook-form';
import AsyncSearchSelectRHF, {
  AsyncSearchSelectProps,
} from '@/components/asyncSelect/AsyncSearchSelectRHF.tsx';
import consentTemplatesApi from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.ts';
import { consentTemplatesApiQueryKeys } from '@/features/dashboard/consentTemplates/api/consentTemplatesApi.queryKeys.ts';
import { ConsentTemplateListDto } from '@/features/dashboard/consentTemplates/types/ConsentTemplateListDto.ts';
import { getConsentTypeLabel } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.utils.ts';

type ConsentTemplateSearchSelectProps<T extends FieldValues> = Omit<
  AsyncSearchSelectProps<T, ConsentTemplateListDto>,
  'fetchFn' | 'toOption' | 'queryKey'
> & {
  fieldPathName: FieldPath<T>;
  control: Control<T>;
};

const ConsentTemplateSearchSelectRHF = <T extends FieldValues>({
  ...props
}: ConsentTemplateSearchSelectProps<T>) => {
  return (
    <AsyncSearchSelectRHF<T, ConsentTemplateListDto>
      {...props}
      queryKey={consentTemplatesApiQueryKeys.all()}
      fetchFn={consentTemplatesApi.getAll}
      idFieldId="templateId"
      toOption={(item) => ({
        // Tour consents are pinned to the stable logical template id, never a
        // specific version id, so the picker submits `templateId`.
        value: item.templateId,
        label: `${item.name} (${getConsentTypeLabel(item.type)})`,
      })}
    />
  );
};

export default ConsentTemplateSearchSelectRHF;
